import useTitleManagement from "./title/setTitleMap";

const useTemplateController = () => {
	return useTitleManagement();
};

export default useTemplateController;
